module.exports = __webpack_public_path__ + "img/analysis_display.15fb714f.png";